const handleCookieData = (() => {
    
    const init = () => {
        bindEnquiryButtons();
        bindBrochureButtons();
        bindFormSubmission();
        bindRemoveLineItems();
    }
    
    const bindEnquiryButtons = () => {
        let isEnquiryButtons = document.querySelectorAll('[data-enquiry-button]');
        if(isEnquiryButtons === null) return;
        isEnquiryButtons.forEach(buttonElm => buttonElm.addEventListener("click", (eve) => {
            eve.preventDefault();            
            const cookie = document.querySelector("[data-umbraco-id]").dataset.umbracoId;
            let getExistingCookie = getCookie("enquiryNodeId");
            let getExistingCookieList = getExistingCookie.split('|');
            if (getExistingCookie && getExistingCookieList.includes(cookie)) {
                window.location = buttonElm.dataset.href;
            } else {
                getExistingCookieList.push(cookie);
                getExistingCookie = getExistingCookieList.filter(n => n).join("|");
                setCookie("enquiryNodeId", getExistingCookie, 1);
                window.location = buttonElm.dataset.href;
            }                     
        }));
    }

    const bindBrochureButtons = () => {
        let isEnquiryButtons = document.querySelectorAll('[data-brochure-button]');
        if(isEnquiryButtons === null) return;
        isEnquiryButtons.forEach(buttonElm => buttonElm.addEventListener("click", (eve) => {
            eve.preventDefault();
            const cookie = document.querySelector("[data-umbraco-id]").dataset.umbracoId;
            setCookie("brochureNodeId", cookie, 1);
            window.location = buttonElm.dataset.href;
        }));
    }
    
    const bindFormSubmission = () => {
        let submitButton = document.querySelector('[data-umb="submit-forms-form"]');
        
        if(submitButton === null) return;
        
        submitButton.addEventListener("click", () => {
            deleteCookies("enquiryNodeId");
            deleteCookies("brochureNodeId");
        })
    }
    
    const bindRemoveLineItems = () => {
        let removeLineItems = document.querySelectorAll('[data-remove-cookie]');
        
        if(removeLineItems === null) return;
        
        removeLineItems.forEach(elm => elm.addEventListener("click", () => {
            let lineItemId = elm.dataset.removeCookie;
            
            deleteCookie("enquiryNodeId", lineItemId);
            
            window.location.reload();
        }))
    }
    
    const setCookie = (name, value, expiryDays) => {
        let expiryDate = new Date().getDate() + (expiryDays * 24 * 60 * 60);
        document.cookie = name + "=" + value + ";" + "expires=" + expiryDate + ";path=/" + ";secure";
    }
    
    const getCookie = (name) => {
        name = name + "=";
        
        let cookies = document.cookie.split(';')
        
        for(let i = 0; i < cookies.length; i++)
        {
            let cookie = cookies[i];
            
            while(cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        
        return "";
    }

    const deleteCookies = (cookies) => {

        document.cookie = cookies + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure";
    }
    
    const deleteCookie = (cookies, cookieToRemove) => {

        let getExistingCookie = getCookie(cookies);
        let getExistingCookieList = getExistingCookie.split('|');
        if (getExistingCookie && getExistingCookieList.includes(cookieToRemove)) {
            getExistingCookie = getExistingCookieList.filter(n => n !== cookieToRemove).join("|");
            
            if (getExistingCookie.length === 0)
            {
                document.cookie = cookies + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure";
            }
            
            setCookie(cookies, getExistingCookie, 1);
        }
    }
    
    return {
        init,
        setCookie,
        getCookie,
        deleteCookie
    }
})();
document.addEventListener("DOMContentLoaded", () => handleCookieData.init())